import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

const initialState={
    actionList:[],
    status:"idle",
    registerstatus:'failure',
    editstatus:'failure',
    deletestatus:'failure',
    error:''
}

export const fetchActions=createAsyncThunk('actions/fetchActions', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/apage/action/getAllActions',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const createAction = createAsyncThunk('actions/createAction', async (actionData)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/apage/action/create',
        {
            method: 'POST',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(actionData)
        }
    )
    return response.json();
})

const actionSlice=createSlice({
    name:"actions",
    initialState,
    reducers:{
        changeRegisterStatus:(state)=>{
            state.registerstatus='failure';
        },
        changeEditStatus:(state)=>{
            state.editstatus='failure';
        },
        changeDeleteStatus:(state)=>{
            state.deletestatus='failure';
        }
    },
    extraReducers:(builder)=>{
        builder
        .addCase(fetchActions.pending,(state)=>{
            state.status='loading'
        })
        .addCase(fetchActions.fulfilled,(state,action)=>{
            state.status='succeeded'
            state.actionList=action.payload
        })
        .addCase(fetchActions.rejected,(state,action)=>{
            state.status='failed'
            state.error=action.error.message
        })
        /*.addCase(createAction.fulfilled,(state,action)=>{
            state.actionList.push(action.payload)
        })*/
        .addCase(createAction.rejected,(state,action)=>{
            state.registerstatus='failure'
            state.error=action.error.message
         })
        .addCase(createAction.pending,(state)=>{
            state.registerstatus='loading'
         })
        .addCase(createAction.fulfilled,(state)=>{
            state.registerstatus='succeeded'
         })
    }
})

export default actionSlice.reducer;